import SetIsActive from '@/common/components/SetIsActive'
import useMutationUpdateLuckyWheel from '@/modules/promotion/api/hooks/useMutateUpdateLuckyWheel'
import { useQueryClient } from '@tanstack/react-query'
import { LuckyWheelQueryKeys } from '@/modules/promotion/keys'
import { GetLuckyWheelResponse } from '@/modules/promotion/type'

interface RequireConnectedLineLuckyWheelProps {
	wheelData: GetLuckyWheelResponse
	onUpdate?: (requireConnectedLine: boolean) => void
}

export function RequireConnectedLineLuckyWheel({
	wheelData,
	onUpdate,
}: RequireConnectedLineLuckyWheelProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: updateLuckyWheel } = useMutationUpdateLuckyWheel()

	const handleMutate = async (value: boolean) => {
		await updateLuckyWheel({
			payload: {
				requireConnectedLine: value,
			},
		})

		// Call the optional callback to update parent component
		onUpdate?.(value)

		// Invalidate the lucky wheel query to refresh the data
		queryClient.invalidateQueries({
			queryKey: [LuckyWheelQueryKeys.GetLuckyWheel],
		})
	}

	return (
		<div className="flex items-center gap-3">
			<span className="text-sm font-medium">ต้องเชื่อมต่อ LINE</span>
			<SetIsActive
				defaultChecked={wheelData.requireConnectedLine ?? false}
				onMutate={handleMutate}
				errorMessage="ไม่สามารถอัพเดทการเชื่อมต่อ LINE ได้"
			/>
		</div>
	)
}
